import React, { forwardRef } from 'react'
import { css } from '@emotion/core'
import { BillboardButton, useTheme } from '@fs/zion-ui'
import PropTypes from 'prop-types'
import { isExternalUrl } from '../helpers/urlHelpers'
import { navConfig } from '../../config'

const buttonHackCss = css`
  & {
    button,
    a {
      border-radius: 2em;
      text-transform: none;
      font-weight: 600;
      font-size: var(--text-size-b);
      white-space: normal !important;
      overflow: visible;
      word-break: unset;
      max-width: fit-content;
      text-align: center;
      height: auto;
      padding-bottom: 13px;
      overflow: hidden;
    }
  }

  &[bigness='sm'] {
    button,
    a {
      display: block !important;
    }
  }
`

const PillButton = forwardRef(({ emphasis = 'high', size = 'lg', children, to, color, ...props }, ref) => {
  const theme = useTheme()
  const external = to ? isExternalUrl(to) : false

  // HACK: we failed to add an exeption for links that go to *.familysearch.org that are not hosted by familysearch.
  const shouldPrependLangCode = navConfig.langCodeBlackList.some((langCode) => to?.includes(langCode))

  // This is a little trick to only send the prop if it is defined. Not sure why it still shows in the DOM when undefined, but I guess this'll work...
  const noPrependLocaleCode = shouldPrependLangCode ? { noPrependLocaleCode: true } : {}

  const themedColor = color || (theme === 'day' && emphasis === 'low' && 'blue') || 'gray'

  return (
    <div css={buttonHackCss} bigness={size}>
      <BillboardButton
        emphasis={emphasis}
        external={to ? external : undefined}
        target={external ? '_blank' : '_self'}
        to={to}
        color={themedColor}
        {...noPrependLocaleCode}
        {...props}
        ref={ref}
      >
        {children}
      </BillboardButton>
    </div>
  )
})
PillButton.propTypes = {
  emphasis: PropTypes.oneOf(['low', 'medium', 'high']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  children: PropTypes.node.isRequired,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  color: PropTypes.string,
  Icon: PropTypes.elementType,
}

export default PillButton
